import { render } from "./networking.k8s.io.ingress.vue?vue&type=template&id=7b63b150"
import script from "./networking.k8s.io.ingress.vue?vue&type=script&lang=js"
export * from "./networking.k8s.io.ingress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__